var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXSquareBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-square",
    clipPath: "url(#clip0_5181_6623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.54541 1.54688L12.4545 12.456",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4545 1.54688L1.54541 12.456",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5181_6623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0909,
    height: 13.0909,
    fill: "white",
    transform: "translate(0.45459 0.455078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSquareBlack);
export default __webpack_public_path__ + "static/media/x-squareBlack.5eab633de4d163c5970b339dd219711b.svg";
export { ForwardRef as ReactComponent };